import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const welcomeMessage = {
  es: "Bienvenid@ a esta pequeña app creada con mucho cariño para todas las personas que conviven con alergias e intolerancias.\n\nEstá especialmente pensada para acompañar a madres, padres y familias que viven cada día con la alergia a la proteína de la leche, la soja y otros alérgenos que pueden complicar la alimentación de los más pequeños.\n\nLos alérgenos incluidos se basan en información contrastada, para ofrecerte una guía fiable en esos momentos de duda frente a una etiqueta. Recuerda que los datos ofrecidos son orientativos y no sustituyen la opinión de un profesional sanitario.\n\nEspero que esta herramienta te haga la vida un poquito más fácil, te dé tranquilidad y te acompañe siempre que la necesites.\n\nSi valoras este proyecto y quieres ayudar a que siga creciendo y mejorando, puedes colaborar descargando la app Premium.\n\nGracias de corazón por estar aquí ♡",
  en: "Welcome to this little app created with love for all people living with allergies and intolerances.\n\nIt's specially designed to accompany mothers, fathers and families living daily with milk protein allergy, soy and other allergens that can complicate feeding the little ones.\n\nThe allergens included are based on verified information, to offer you a reliable guide in those moments of doubt in front of a label. Remember that the data provided is for guidance only and does not replace the opinion of a healthcare professional.\n\nI hope this tool makes your life a little easier, gives you peace of mind and accompanies you whenever you need it.\n\nIf you value this project and want to help it continue growing and improving, you can collaborate by downloading the Premium app.\n\nThank you from the heart for being here ♡",
  fr: "Bienvenue dans cette petite application créée avec amour pour toutes les personnes vivant avec des allergies et intolérances.\n\nElle est spécialement conçue pour accompagner les mères, pères et familles vivant au quotidien avec l'allergie aux protéines de lait, au soja et autres allergènes qui peuvent compliquer l'alimentation des petits.\n\nLes allergènes inclus sont basés sur des informations vérifiées, pour vous offrir un guide fiable dans ces moments de doute face à une étiquette. N'oubliez pas que les données fournies sont indicatives et ne remplacent pas l'avis d'un professionnel de santé.\n\nJ'espère que cet outil vous facilitera un peu la vie, vous rassurera et vous accompagnera quand vous en aurez besoin.\n\nSi vous appréciez ce projet et souhaitez l'aider à continuer de grandir et s'améliorer, vous pouvez collaborer en téléchargeant l'application Premium.\n\nMerci du fond du cœur d'être ici ♡",
  de: "Willkommen zu dieser kleinen App, die mit viel Liebe für alle Menschen erstellt wurde, die mit Allergien und Unverträglichkeiten leben.\n\nSie ist speziell entwickelt, um Mütter, Väter und Familien zu begleiten, die täglich mit Milcheiweißallergie, Soja und anderen Allergenen leben, die die Ernährung der Kleinen erschweren können.\n\nDie enthaltenen Allergene basieren auf verifizierten Informationen, um Ihnen einen zuverlässigen Leitfaden in diesen Momenten des Zweifels vor einem Etikett zu bieten. Denken Sie daran, dass die bereitgestellten Daten nur als Orientierung dienen und nicht die Meinung eines medizinischen Fachpersonals ersetzen.\n\nIch hoffe, dass dieses Tool Ihr Leben ein wenig einfacher macht, Ihnen Seelenfrieden gibt und Sie begleitet, wann immer Sie es brauchen.\n\nWenn Sie dieses Projekt schätzen und helfen möchten, dass es weiter wächst und sich verbessert, können Sie mitarbeiten, indem Sie die Premium-App herunterladen.\n\nHerzlichen Dank, dass Sie hier sind ♡",
  ca: "Benvingut/da a aquesta petita app creada amb molt d'afecte per a totes les persones que conviuen amb al·lèrgies i intoleràncies.\n\nEstà especialment pensada per acompanyar mares, pares i famílies que viuen cada dia amb l'al·lèrgia a la proteïna de la llet, la soja i altres al·lèrgens que poden complicar l'alimentació dels més petits.\n\nEls al·lèrgens inclosos es basen en informació contrastada, per oferir-te una guia fiable en aquells moments de dubte davant d'una etiqueta. Recorda que les dades ofertes són orientatives i no substitueixen l'opinió d'un professional sanitari.\n\nEspero que aquesta eina et faci la vida una mica més fàcil, et doni tranquil·litat i t'acompanyi sempre que la necessitis.\n\nSi valores aquest projecte i vols ajudar que continuï creixent i millorant, pots col·laborar descarregant l'app Premium.\n\nGràcies de cor per ser aquí ♡",
  eu: "Ongi etorri alergia eta intolerantziekin bizi diren pertsona guztientzat maitasunez sortutako aplikazio txiki honetara.\n\nBereziki diseinatuta dago esneko proteinaren alergia, soja eta elikadura zaildu dezaketen beste alergeno batzuekin egunero bizi diren ama, aita eta familientzat.\n\nBarnean dauden alergenoak egiaztatutako informazioan oinarritzen dira, etiketa baten aurrean zalantzaren une horietan gida fidagarria eskaintzeko. Gogoratu emandako datuak orientagarriak direla eta ez dutela osasun profesional baten iritzia ordezkatzen.\n\nEspero dut tresna honek zure bizitza piska bat errazagoa egiten dizula, lasaitasuna ematen dizula eta behar duzun guztietan laguntzen dizula.\n\nProiektu hau baloratzen baduzu eta hazten eta hobetzen jarraitzen lagundu nahi baduzu, Premium aplikazioa deskargatuz lagundu dezakezu.\n\nBihotz-bihotzez eskerrik asko hemen egoteagatik ♡",
  gl: "Benvido/a a esta pequena app creada con moito cariño para todas as persoas que conviven con alerxias e intolerancias.\n\nEstá especialmente pensada para acompañar a nais, pais e familias que viven cada día coa alerxia á proteína do leite, a soia e outros alerxenos que poden complicar a alimentación dos máis pequenos.\n\nOs alerxenos incluídos baséanse en información contrastada, para ofrecerche unha guía fiable neses momentos de dúbida fronte a unha etiqueta. Lembra que os datos ofrecidos son orientativos e non substitúen a opinión dun profesional sanitario.\n\nEspero que esta ferramenta che faga a vida un pouquiño máis fácil, che dea tranquilidade e te acompañe sempre que a necesites.\n\nSe valoras este proxecto e queres axudar a que siga crecendo e mellorando, podes colaborar descargando a app Premium.\n\nGrazas de corazón por estar aquí ♡",
  it: "Benvenuto/a in questa piccola app creata con tanto amore per tutte le persone che convivono con allergie e intolleranze.\n\nÈ appositamente pensata per accompagnare madri, padri e famiglie che vivono ogni giorno con l'allergia alle proteine del latte, alla soia e altri allergeni che possono complicare l'alimentazione dei più piccoli.\n\nGli allergeni inclusi si basano su informazioni verificate, per offrirti una guida affidabile in quei momenti di dubbio davanti a un'etichetta. Ricorda che i dati forniti sono indicativi e non sostituiscono il parere di un professionista sanitario.\n\nSpero che questo strumento ti renda la vita un po' più facile, ti dia tranquillità e ti accompagni ogni volta che ne hai bisogno.\n\nSe apprezzi questo progetto e vuoi aiutarlo a continuare a crescere e migliorare, puoi collaborare scaricando l'app Premium.\n\nGrazie di cuore per essere qui ♡"
};

const resources = {
  es: {
    translation: {
      welcomeMessage: welcomeMessage.es,
      appTitle: 'Detector de Alérgenos',
      appInfo: 'Información de la App',
      favorites: 'Favoritos',
      profiles: 'Perfiles',
      suggestions: 'Sugerencias',
      scanBarcode: 'Escanear Código',
      myAllergens: 'Mis Alérgenos',
      scanProduct: 'Escanear Producto',
      enterBarcode: 'Ingresa el código de barras',
      barcodePlaceholder: 'Ej: 8480000123456',
      search: 'Buscar',
      startScanning: 'Iniciar Escáner',
      takePhoto: 'Hacer Foto',
      stopScanning: 'Detener Escáner',
      configureAllergens: 'Configurar Alérgenos',
      selectAllergens: 'Selecciona los alérgenos que quieres monitorear',
      saveConfiguration: 'Guardar Configuración',
      configSaved: 'Configuración guardada correctamente',
      safeToConsume: '✓ Seguro para consumir',
      containsAllergens: '⚠ Contiene alérgenos',
      productNotFound: 'Producto no encontrado',
      productNotFoundDesc: 'No se encontró información para este código de barras',
      ingredients: 'Ingredientes',
      allergenDetected: 'Alérgeno detectado',
      foundIn: 'Encontrado en',
      additives: 'Aditivos',
      brands: 'Marcas',
      noAllergensConfigured: 'No has configurado alérgenos',
      configureFirst: 'Configura tus alérgenos primero para comenzar a escanear productos',
      goToConfig: 'Ir a Configuración',
      
      // Allergens
      dairy: 'Lácteos',
      lactose: 'Lactosa',
      gluten: 'Gluten',
      egg: 'Huevo',
      fish: 'Pescado',
      soy: 'Soja',
      nuts: 'Frutos Secos',
      shellfish: 'Mariscos',
      sulfites: 'Sulfitos',
      celery: 'Apio',
      mustard: 'Mostaza',
      sesame: 'Sésamo',
      lupins: 'Altramuces',
      
      // Suggestions
      suggestionBox: 'Buzón de Sugerencias',
      suggestionBoxDesc: 'Comparte tus comentarios y sugerencias',
      yourName: 'Tu nombre (opcional)',
      yourEmail: 'Tu email (opcional)',
      yourMessage: 'Tu mensaje',
      messagePlaceholder: 'Escribe aquí tus comentarios o sugerencias...',
      sendSuggestion: 'Enviar',
      suggestionSent: '¡Mensaje enviado!',
      thankYouFeedback: 'Gracias por tu feedback',
      messageRequired: 'El mensaje es requerido',
      close: 'Cerrar',
      showWelcome: 'Ver mensaje de bienvenida',
      
      // Favorites
      myFavorites: 'Mis Favoritos',
      noFavoritesYet: 'Aún no has añadido favoritos',
      addToFavorites: 'Añadir a favoritos',
      removeFromFavorites: 'Quitar de favoritos',
      addedToFavorites: 'Añadido a favoritos',
      favoritesRequiresUpgrade: 'Has alcanzado el límite de 3 favoritos gratis. Activa Premium o código Beta para ilimitados.',
      errorSavingFavorite: 'Error al guardar favorito',
      removedFromFavorites: 'Eliminado de favoritos',
      scanHistory: 'Historial de escaneos',
      noHistoryYet: 'Aún no has escaneado ningún producto',
      clearHistory: 'Borrar todo',
      confirmClearHistory: '¿Borrar todo el historial?',
      
      // Profiles
      allergenProfiles: 'Perfiles de Alérgenos',
      saveAsProfile: 'Guardar como Perfil',
      profileName: 'Nombre del perfil',
      profileNamePlaceholder: 'Ej: Perfil de María',
      saveProfile: 'Guardar Perfil',
      loadProfile: 'Cargar',
      deleteProfile: 'Eliminar',
      profileSaved: 'Perfil guardado',
      profileLoaded: 'Perfil cargado',
      profileDeleted: 'Perfil eliminado',
      noProfilesYet: 'No tienes perfiles guardados',
      profileNameRequired: 'El nombre del perfil es requerido',
      
      // Suggested Products
      suggestedProducts: 'Productos Sugeridos',
      safeDairyFree: 'Seguro - Sin lácteos',
      safeAlternative: 'Alternativa segura',
      freeFrom: 'Sin',
      safeFor: 'Adecuado para tu perfil',
      noneOfYourAllergens: 'No contiene ninguno de tus alérgenos',
      
      // Custom Allergens
      addCustomAllergen: 'Añadir Alérgeno Personalizado',
      allergenName: 'Nombre del alérgeno',
      keywords: 'Palabras clave (separadas por coma)',
      customAdditives: 'Aditivos (ej: E270, E322)',
      suggestAllergen: 'Sugerir Alérgeno',
      suggestAllergenDesc: '¿No encuentras un alérgeno? Envíanos tu sugerencia a allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Sugerencia de alérgeno enviada',
      
      // Landing page
      heroTitle: 'Escanea alimentos y detecta alérgenos en segundos',
      heroSubtitle: 'Gratis. Rápido. Sin registro.',
      installOnMobile: 'Instalar en tu móvil',
      whatItDoes: 'Qué hace la app',
      scanBarcodes: 'Escanea códigos de barras',
      identifyAllergens: 'Identifica alérgenos automáticamente',
      customList: 'Lista personalizada de tus alergias',
      worksPWA: 'Funciona como PWA (instalable sin Play Store)',
      realScreenshots: 'Capturas reales',
      closeLanding: 'Cerrar',
      contribute: 'Contribuir',
      comingSoon: 'Próximamente',
      startNow: 'Comienza ahora',
      joinThousands: 'Únete a miles de familias que ya usan nuestra app para vivir más tranquilas',
      scanScreen: 'Pantalla de escaneo',
      productResult: 'Resultado del alimento',
      allergenSelection: 'Selección de alérgenos',
      
      // PWA Install Instructions
      installInstructions: 'Instalar en tu dispositivo',
      alreadyInstalled: '¡La app ya está instalada!',
      appInstalled: '¡App instalada correctamente!',
      iosInstallTitle: 'Para instalar en iPhone/iPad:',
      iosStep1: 'Toca el botón de compartir',
      iosStep2: 'Desliza hacia abajo y toca "Añadir a pantalla de inicio"',
      iosStep3: 'Toca "Añadir" en la esquina superior derecha',
      androidInstallTitle: 'Para instalar:',
      androidStep1: 'Abre el menú de tu navegador (⋮)',
      androidStep2: 'Selecciona "Instalar aplicación" o "Añadir a pantalla de inicio"',
      androidStep3: 'Confirma la instalación',
      continueToApp: 'Continuar a la app',
      
      // Premium
      getPremium: 'Obtener Premium',
      getPremiumNow: 'Obtener Premium - €1,99/mes',
      premiumTitle: 'Versión Premium',
      premiumDescription: 'Descarga la versión Premium para disfrutar de funciones avanzadas y ayudar a mantener la app.',
      premiumNoAds: 'Sin publicidad',
      premiumMoreSuggestions: 'Más sugerencias',
      premiumUnlimitedFavorites: 'Favoritos ilimitados',
      premiumUnlimitedProfiles: 'Perfiles ilimitados',
      premiumSupport: 'Apoya el proyecto',
      unlockMoreSuggestions: 'Desbloquear más sugerencias',
      unlockUnlimitedProfiles: 'Añadir perfiles ilimitados',
      unlockUnlimitedFavorites: 'Guardar productos ilimitados',
      
      // Benefits
      benefits: 'Beneficios',
      benefitAllergies: 'Ideal para personas con alergias',
      benefitParents: 'Perfecto para mamás/papás con hijos con intolerancias o alergias',
      benefitSupermarket: 'Útil en el supermercado',
      benefitNoReading: 'Evita leer ingredientes y aditivos complicados',
      
      // Privacy Policy
      privacyPolicy: 'Política de Privacidad',
      privacyLastUpdated: 'Última actualización',
      privacyIntro: 'En Detector de Alérgenos, nos tomamos muy en serio la privacidad de nuestros usuarios. Esta política describe qué información recopilamos, cómo la usamos y los derechos que tienes sobre tus datos.',
      privacyDataCollected: 'Datos que recopilamos',
      privacyDataCollectedDesc: 'Recopilamos la siguiente información para proporcionar y mejorar nuestros servicios:',
      privacyDataItem1: 'Configuración de alérgenos: Los alérgenos que seleccionas para monitorear',
      privacyDataItem2: 'Historial de escaneos: Los códigos de barras que escaneas (vinculados a un ID anónimo)',
      privacyDataItem3: 'Productos favoritos: Los productos que guardas como favoritos',
      privacyDataItem4: 'Perfiles de alérgenos: Los perfiles que creas para diferentes personas',
      privacyDataItem5: 'ID de usuario anónimo: Un identificador único generado localmente (UUID) para asociar tus datos',
      privacyHowWeUse: 'Cómo usamos tus datos',
      privacyHowWeUseDesc: 'Utilizamos tus datos exclusivamente para:',
      privacyUseItem1: 'Analizar productos y detectar alérgenos según tu configuración',
      privacyUseItem2: 'Guardar tus preferencias y favoritos',
      privacyUseItem3: 'Sugerirte productos alternativos seguros',
      privacyUseItem4: 'Mejorar la experiencia de la aplicación',
      privacyNoShare: 'No compartimos tus datos',
      privacyNoShareDesc: 'Tus datos nunca se venden ni se comparten con terceros. La información se almacena de forma segura y solo se utiliza para el funcionamiento de la app.',
      privacyRights: 'Tus derechos',
      privacyRightsDesc: 'Tienes derecho a:',
      privacyRightItem1: 'Acceder a tus datos almacenados',
      privacyRightItem2: 'Eliminar tus datos en cualquier momento',
      privacyRightItem3: 'Exportar tus datos',
      privacyRightItem4: 'Revocar permisos de acceso',
      privacyContact: 'Contacto',
      privacyContactDesc: 'Si tienes preguntas sobre esta política de privacidad, puedes contactarnos en:',
      privacyCookies: 'Cookies y almacenamiento local',
      privacyCookiesDesc: 'Utilizamos localStorage para guardar tu ID de usuario anónimo y preferencias. No utilizamos cookies de seguimiento de terceros.',
      privacyChanges: 'Cambios en esta política',
      privacyChangesDesc: 'Podemos actualizar esta política ocasionalmente. Te notificaremos cualquier cambio significativo a través de la aplicación.'
    }
  },
  en: {
    translation: {
      welcomeMessage: welcomeMessage.en,
      appTitle: 'Allergen Detector',
      appInfo: 'App Information',
      favorites: 'Favorites',
      profiles: 'Profiles',
      suggestions: 'Suggestions',
      scanBarcode: 'Scan Code',
      myAllergens: 'My Allergens',
      scanProduct: 'Scan Product',
      enterBarcode: 'Enter barcode',
      barcodePlaceholder: 'E.g: 8480000123456',
      search: 'Search',
      startScanning: 'Start Scanner',
      stopScanning: 'Stop Scanner',
      configureAllergens: 'Configure Allergens',
      selectAllergens: 'Select the allergens you want to monitor',
      saveConfiguration: 'Save Configuration',
      configSaved: 'Configuration saved successfully',
      safeToConsume: '✓ Safe to consume',
      containsAllergens: '⚠ Contains allergens',
      productNotFound: 'Product not found',
      productNotFoundDesc: 'No information found for this barcode',
      ingredients: 'Ingredients',
      allergenDetected: 'Allergen detected',
      foundIn: 'Found in',
      additives: 'Additives',
      brands: 'Brands',
      noAllergensConfigured: 'No allergens configured',
      configureFirst: 'Configure your allergens first to start scanning products',
      goToConfig: 'Go to Configuration',
      
      dairy: 'Dairy',
      lactose: 'Lactose',
      gluten: 'Gluten',
      egg: 'Egg',
      fish: 'Fish',
      soy: 'Soy',
      nuts: 'Nuts',
      shellfish: 'Shellfish',
      sulfites: 'Sulfites',
      celery: 'Celery',
      mustard: 'Mustard',
      sesame: 'Sesame',
      lupins: 'Lupins',
      
      suggestionBox: 'Suggestion Box',
      suggestionBoxDesc: 'Share your comments and suggestions',
      yourName: 'Your name (optional)',
      yourEmail: 'Your email (optional)',
      yourMessage: 'Your message',
      messagePlaceholder: 'Write your comments or suggestions here...',
      sendSuggestion: 'Send',
      suggestionSent: 'Message sent!',
      thankYouFeedback: 'Thank you for your feedback',
      messageRequired: 'Message is required',
      close: 'Close',
      showWelcome: 'Show welcome message',
      
      myFavorites: 'My Favorites',
      noFavoritesYet: 'No favorites added yet',
      addToFavorites: 'Add to favorites',
      removeFromFavorites: 'Remove from favorites',
      addedToFavorites: 'Added to favorites',
      favoritesRequiresUpgrade: 'You have reached the limit of 3 free favorites. Activate Premium or Beta code for unlimited.',
      errorSavingFavorite: 'Error saving favorite',
      removedFromFavorites: 'Removed from favorites',
      scanHistory: 'Scan history',
      noHistoryYet: 'No products scanned yet',
      clearHistory: 'Clear all',
      confirmClearHistory: 'Clear all history?',
      
      allergenProfiles: 'Allergen Profiles',
      saveAsProfile: 'Save as Profile',
      profileName: 'Profile name',
      profileNamePlaceholder: 'E.g: Maria\'s Profile',
      saveProfile: 'Save Profile',
      loadProfile: 'Load',
      deleteProfile: 'Delete',
      profileSaved: 'Profile saved',
      profileLoaded: 'Profile loaded',
      profileDeleted: 'Profile deleted',
      noProfilesYet: 'No saved profiles',
      profileNameRequired: 'Profile name is required',
      
      suggestedProducts: 'Suggested Products',
      safeDairyFree: 'Safe - Dairy Free',
      safeAlternative: 'Safe alternative',
      
      addCustomAllergen: 'Add Custom Allergen',
      allergenName: 'Allergen name',
      keywords: 'Keywords (comma separated)',
      customAdditives: 'Additives (e.g: E270, E322)',
      suggestAllergen: 'Suggest Allergen',
      suggestAllergenDesc: 'Can\'t find an allergen? Send us your suggestion to allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Allergen suggestion sent',
      
      // Landing page
      heroTitle: 'Scan food and detect allergens in seconds',
      heroSubtitle: 'Free. Fast. No registration.',
      installOnMobile: 'Install on your mobile',
      whatItDoes: 'What does the app do',
      scanBarcodes: 'Scan barcodes',
      identifyAllergens: 'Automatically identify allergens',
      customList: 'Personalized list of your allergies',
      worksPWA: 'Works as PWA (installable without Play Store)',
      realScreenshots: 'Real screenshots',
      closeLanding: 'Close',
      contribute: 'Contribute',
      comingSoon: 'Coming soon',
      startNow: 'Start now',
      joinThousands: 'Join thousands of families already using our app to live more peacefully',
      scanScreen: 'Scan screen',
      productResult: 'Product result',
      allergenSelection: 'Allergen selection',
      
      // PWA Install Instructions
      installInstructions: 'Install on your device',
      alreadyInstalled: 'The app is already installed!',
      appInstalled: 'App installed successfully!',
      iosInstallTitle: 'To install on iPhone/iPad:',
      iosStep1: 'Tap the share button',
      iosStep2: 'Scroll down and tap "Add to Home Screen"',
      iosStep3: 'Tap "Add" in the top right corner',
      androidInstallTitle: 'To install:',
      androidStep1: 'Open your browser menu (⋮)',
      androidStep2: 'Select "Install app" or "Add to Home Screen"',
      androidStep3: 'Confirm the installation',
      continueToApp: 'Continue to app',
      
      benefits: 'Benefits',
      benefitAllergies: 'Ideal for people with allergies',
      benefitParents: 'Perfect for moms/dads with children with intolerances or allergies',
      benefitSupermarket: 'Useful at the supermarket',
      benefitNoReading: 'Avoid reading complicated ingredients and additives',
      
      // Privacy Policy
      privacyPolicy: 'Privacy Policy',
      privacyLastUpdated: 'Last updated',
      privacyIntro: 'At Allergen Detector, we take the privacy of our users very seriously. This policy describes what information we collect, how we use it, and the rights you have over your data.',
      privacyDataCollected: 'Data we collect',
      privacyDataCollectedDesc: 'We collect the following information to provide and improve our services:',
      privacyDataItem1: 'Allergen settings: The allergens you select to monitor',
      privacyDataItem2: 'Scan history: The barcodes you scan (linked to an anonymous ID)',
      privacyDataItem3: 'Favorite products: The products you save as favorites',
      privacyDataItem4: 'Allergen profiles: The profiles you create for different people',
      privacyDataItem5: 'Anonymous user ID: A unique identifier generated locally (UUID) to associate your data',
      privacyHowWeUse: 'How we use your data',
      privacyHowWeUseDesc: 'We use your data exclusively to:',
      privacyUseItem1: 'Analyze products and detect allergens according to your settings',
      privacyUseItem2: 'Save your preferences and favorites',
      privacyUseItem3: 'Suggest safe alternative products',
      privacyUseItem4: 'Improve the app experience',
      privacyNoShare: 'We do not share your data',
      privacyNoShareDesc: 'Your data is never sold or shared with third parties. Information is stored securely and only used for app functionality.',
      privacyRights: 'Your rights',
      privacyRightsDesc: 'You have the right to:',
      privacyRightItem1: 'Access your stored data',
      privacyRightItem2: 'Delete your data at any time',
      privacyRightItem3: 'Export your data',
      privacyRightItem4: 'Revoke access permissions',
      privacyContact: 'Contact',
      privacyContactDesc: 'If you have questions about this privacy policy, you can contact us at:',
      privacyCookies: 'Cookies and local storage',
      privacyCookiesDesc: 'We use localStorage to save your anonymous user ID and preferences. We do not use third-party tracking cookies.',
      privacyChanges: 'Changes to this policy',
      privacyChangesDesc: 'We may update this policy occasionally. We will notify you of any significant changes through the app.'
    }
  },
  fr: {
    translation: {
      welcomeMessage: welcomeMessage.fr,
      appTitle: 'Détecteur d\'Allergènes',
      appInfo: 'Informations sur l\'App',
      favorites: 'Favoris',
      profiles: 'Profils',
      suggestions: 'Suggestions',
      scanBarcode: 'Scanner',
      myAllergens: 'Mes Allergènes',
      scanProduct: 'Scanner Produit',
      enterBarcode: 'Entrez le code-barres',
      barcodePlaceholder: 'Ex: 8480000123456',
      search: 'Rechercher',
      startScanning: 'Démarrer',
      stopScanning: 'Arrêter',
      configureAllergens: 'Configurer',
      selectAllergens: 'Sélectionnez les allergènes',
      saveConfiguration: 'Enregistrer',
      configSaved: 'Configuration enregistrée',
      safeToConsume: '✓ Sûr',
      containsAllergens: '⚠ Contient allergènes',
      productNotFound: 'Produit non trouvé',
      productNotFoundDesc: 'Aucune information trouvée',
      ingredients: 'Ingrédients',
      allergenDetected: 'Allergène détecté',
      foundIn: 'Trouvé dans',
      additives: 'Additifs',
      brands: 'Marques',
      noAllergensConfigured: 'Pas d\'allergènes configurés',
      configureFirst: 'Configurez vos allergènes d\'abord',
      goToConfig: 'Configuration',
      
      dairy: 'Produits Laitiers',
      lactose: 'Lactose',
      gluten: 'Gluten',
      egg: 'Œuf',
      fish: 'Poisson',
      soy: 'Soja',
      nuts: 'Fruits à Coque',
      shellfish: 'Crustacés',
      sulfites: 'Sulfites',
      celery: 'Céleri',
      mustard: 'Moutarde',
      sesame: 'Sésame',
      lupins: 'Lupins',
      
      suggestionBox: 'Boîte à Suggestions',
      suggestionBoxDesc: 'Partagez vos commentaires',
      yourName: 'Votre nom (optionnel)',
      yourEmail: 'Votre email (optionnel)',
      yourMessage: 'Votre message',
      messagePlaceholder: 'Écrivez vos commentaires...',
      sendSuggestion: 'Envoyer',
      suggestionSent: 'Message envoyé!',
      thankYouFeedback: 'Merci pour votre retour',
      messageRequired: 'Message requis',
      close: 'Fermer',
      
      myFavorites: 'Mes Favoris',
      noFavoritesYet: 'Pas encore de favoris',
      addToFavorites: 'Ajouter aux favoris',
      removeFromFavorites: 'Retirer des favoris',
      addedToFavorites: 'Ajouté aux favoris',
      favoritesRequiresUpgrade: 'Les favoris nécessitent Premium ou code Beta',
      errorSavingFavorite: 'Erreur lors de l\'enregistrement du favori',
      removedFromFavorites: 'Retiré des favoris',
      scanHistory: 'Historique de scans',
      noHistoryYet: 'Aucun produit scanné pour le moment',
      clearHistory: 'Tout effacer',
      confirmClearHistory: 'Effacer tout l\'historique ?',
      
      allergenProfiles: 'Profils d\'Allergènes',
      saveAsProfile: 'Sauvegarder comme Profil',
      profileName: 'Nom du profil',
      profileNamePlaceholder: 'Ex: Profil de Marie',
      saveProfile: 'Sauvegarder',
      loadProfile: 'Charger',
      deleteProfile: 'Supprimer',
      profileSaved: 'Profil sauvegardé',
      profileLoaded: 'Profil chargé',
      profileDeleted: 'Profil supprimé',
      noProfilesYet: 'Pas de profils sauvegardés',
      profileNameRequired: 'Nom requis',
      
      suggestedProducts: 'Produits Suggérés',
      safeDairyFree: 'Sûr - Sans lactose',
      safeAlternative: 'Alternative sûre',
      
      addCustomAllergen: 'Ajouter Allergène Personnalisé',
      allergenName: 'Nom de l\'allergène',
      keywords: 'Mots-clés (séparés par virgule)',
      customAdditives: 'Additifs (ex: E270, E322)',
      suggestAllergen: 'Suggérer Allergène',
      suggestAllergenDesc: 'Vous ne trouvez pas un allergène? Envoyez-nous votre suggestion à allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Suggestion d\'allergène envoyée',
      
      heroTitle: 'Scannez les aliments et détectez les allergènes en secondes',
      heroSubtitle: 'Gratuit. Rapide. Sans inscription.',
      installOnMobile: 'Installer sur votre mobile',
      whatItDoes: 'Que fait l\'application',
      scanBarcodes: 'Scanner les codes-barres',
      identifyAllergens: 'Identifier automatiquement les allergènes',
      customList: 'Liste personnalisée de vos allergies',
      worksPWA: 'Fonctionne comme PWA (installable sans Play Store)',
      realScreenshots: 'Captures réelles',
      closeLanding: 'Fermer',
      contribute: 'Contribuer',
      comingSoon: 'Bientôt',
      startNow: 'Commencer maintenant',
      joinThousands: 'Rejoignez des milliers de familles qui utilisent déjà notre application pour vivre plus sereinement',
      scanScreen: 'Écran de scan',
      productResult: 'Résultat du produit',
      allergenSelection: 'Sélection d\'allergènes',
      
      // PWA Install Instructions
      installInstructions: 'Installer sur votre appareil',
      alreadyInstalled: 'L\'application est déjà installée!',
      appInstalled: 'Application installée avec succès!',
      iosInstallTitle: 'Pour installer sur iPhone/iPad:',
      iosStep1: 'Appuyez sur le bouton de partage',
      iosStep2: 'Faites défiler et appuyez sur "Sur l\'écran d\'accueil"',
      iosStep3: 'Appuyez sur "Ajouter" en haut à droite',
      androidInstallTitle: 'Pour installer:',
      androidStep1: 'Ouvrez le menu du navigateur (⋮)',
      androidStep2: 'Sélectionnez "Installer l\'application" ou "Ajouter à l\'écran d\'accueil"',
      androidStep3: 'Confirmez l\'installation',
      continueToApp: 'Continuer vers l\'app',
      
      benefits: 'Avantages',
      benefitAllergies: 'Idéal pour les personnes allergiques',
      benefitParents: 'Parfait pour les mamans/papas avec des enfants ayant des intolérances ou allergies',
      benefitSupermarket: 'Utile au supermarché',
      benefitNoReading: 'Évitez de lire des ingrédients et additifs compliqués',
      
      // Privacy Policy
      privacyPolicy: 'Politique de confidentialité',
      privacyLastUpdated: 'Dernière mise à jour',
      privacyIntro: 'Chez Détecteur d\'Allergènes, nous prenons très au sérieux la confidentialité de nos utilisateurs. Cette politique décrit quelles informations nous collectons, comment nous les utilisons et les droits que vous avez sur vos données.',
      privacyDataCollected: 'Données que nous collectons',
      privacyDataCollectedDesc: 'Nous collectons les informations suivantes pour fournir et améliorer nos services:',
      privacyDataItem1: 'Paramètres allergènes: Les allergènes que vous sélectionnez pour surveiller',
      privacyDataItem2: 'Historique des scans: Les codes-barres que vous scannez (liés à un ID anonyme)',
      privacyDataItem3: 'Produits favoris: Les produits que vous enregistrez comme favoris',
      privacyDataItem4: 'Profils allergènes: Les profils que vous créez pour différentes personnes',
      privacyDataItem5: 'ID utilisateur anonyme: Un identifiant unique généré localement (UUID) pour associer vos données',
      privacyHowWeUse: 'Comment nous utilisons vos données',
      privacyHowWeUseDesc: 'Nous utilisons vos données exclusivement pour:',
      privacyUseItem1: 'Analyser les produits et détecter les allergènes selon vos paramètres',
      privacyUseItem2: 'Enregistrer vos préférences et favoris',
      privacyUseItem3: 'Vous suggérer des produits alternatifs sûrs',
      privacyUseItem4: 'Améliorer l\'expérience de l\'application',
      privacyNoShare: 'Nous ne partageons pas vos données',
      privacyNoShareDesc: 'Vos données ne sont jamais vendues ni partagées avec des tiers. Les informations sont stockées en toute sécurité et utilisées uniquement pour le fonctionnement de l\'app.',
      privacyRights: 'Vos droits',
      privacyRightsDesc: 'Vous avez le droit de:',
      privacyRightItem1: 'Accéder à vos données stockées',
      privacyRightItem2: 'Supprimer vos données à tout moment',
      privacyRightItem3: 'Exporter vos données',
      privacyRightItem4: 'Révoquer les autorisations d\'accès',
      privacyContact: 'Contact',
      privacyContactDesc: 'Si vous avez des questions sur cette politique de confidentialité, vous pouvez nous contacter à:',
      privacyCookies: 'Cookies et stockage local',
      privacyCookiesDesc: 'Nous utilisons localStorage pour enregistrer votre ID utilisateur anonyme et vos préférences. Nous n\'utilisons pas de cookies de suivi tiers.',
      privacyChanges: 'Modifications de cette politique',
      privacyChangesDesc: 'Nous pouvons mettre à jour cette politique occasionnellement. Nous vous informerons de tout changement significatif via l\'application.'
    }
  },
  de: {
    translation: {
      welcomeMessage: welcomeMessage.de,
      appTitle: 'Allergen-Detektor',
      appInfo: 'App-Informationen',
      favorites: 'Favoriten',
      profiles: 'Profile',
      suggestions: 'Vorschläge',
      scanBarcode: 'Scannen',
      myAllergens: 'Meine Allergene',
      scanProduct: 'Produkt Scannen',
      enterBarcode: 'Barcode eingeben',
      barcodePlaceholder: 'Z.B: 8480000123456',
      search: 'Suchen',
      startScanning: 'Starten',
      stopScanning: 'Stoppen',
      configureAllergens: 'Konfigurieren',
      selectAllergens: 'Wählen Sie die Allergene',
      saveConfiguration: 'Speichern',
      configSaved: 'Gespeichert',
      safeToConsume: '✓ Sicher',
      containsAllergens: '⚠ Enthält Allergene',
      productNotFound: 'Nicht gefunden',
      productNotFoundDesc: 'Keine Informationen',
      ingredients: 'Zutaten',
      allergenDetected: 'Allergen erkannt',
      foundIn: 'Gefunden in',
      additives: 'Zusatzstoffe',
      brands: 'Marken',
      noAllergensConfigured: 'Keine Allergene',
      configureFirst: 'Konfigurieren Sie zuerst',
      goToConfig: 'Konfiguration',
      
      dairy: 'Milchprodukte',
      lactose: 'Laktose',
      gluten: 'Gluten',
      egg: 'Ei',
      fish: 'Fisch',
      soy: 'Soja',
      nuts: 'Nüsse',
      shellfish: 'Schalentiere',
      sulfites: 'Sulfite',
      celery: 'Sellerie',
      mustard: 'Senf',
      sesame: 'Sesam',
      lupins: 'Lupinen',
      
      suggestionBox: 'Vorschlagsbox',
      suggestionBoxDesc: 'Teilen Sie Ihre Kommentare',
      yourName: 'Ihr Name (optional)',
      yourEmail: 'Ihre E-Mail (optional)',
      yourMessage: 'Ihre Nachricht',
      messagePlaceholder: 'Schreiben Sie hier...',
      sendSuggestion: 'Senden',
      suggestionSent: 'Nachricht gesendet!',
      thankYouFeedback: 'Vielen Dank',
      messageRequired: 'Nachricht erforderlich',
      close: 'Schließen',
      
      myFavorites: 'Meine Favoriten',
      noFavoritesYet: 'Noch keine Favoriten',
      addToFavorites: 'Zu Favoriten',
      removeFromFavorites: 'Aus Favoriten entfernen',
      addedToFavorites: 'Zu Favoriten hinzugefügt',
      favoritesRequiresUpgrade: 'Favoriten erfordern Premium oder Beta-Code',
      errorSavingFavorite: 'Fehler beim Speichern des Favoriten',
      removedFromFavorites: 'Aus Favoriten entfernt',
      scanHistory: 'Scanverlauf',
      noHistoryYet: 'Noch keine Produkte gescannt',
      clearHistory: 'Alle löschen',
      confirmClearHistory: 'Gesamten Verlauf löschen?',
      
      allergenProfiles: 'Allergen-Profile',
      saveAsProfile: 'Als Profil speichern',
      profileName: 'Profilname',
      profileNamePlaceholder: 'Z.B: Marias Profil',
      saveProfile: 'Speichern',
      loadProfile: 'Laden',
      deleteProfile: 'Löschen',
      profileSaved: 'Profil gespeichert',
      profileLoaded: 'Profil geladen',
      profileDeleted: 'Profil gelöscht',
      noProfilesYet: 'Keine Profile',
      profileNameRequired: 'Name erforderlich',
      
      suggestedProducts: 'Vorgeschlagene Produkte',
      safeDairyFree: 'Sicher - Milchfrei',
      safeAlternative: 'Sichere Alternative',
      
      addCustomAllergen: 'Benutzerdefiniertes Allergen hinzufügen',
      allergenName: 'Name des Allergens',
      keywords: 'Schlüsselwörter (durch Komma getrennt)',
      customAdditives: 'Zusatzstoffe (z.B: E270, E322)',
      suggestAllergen: 'Allergen vorschlagen',
      suggestAllergenDesc: 'Können Sie ein Allergen nicht finden? Senden Sie uns Ihren Vorschlag an allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Allergenvorschlag gesendet',
      
      heroTitle: 'Scannen Sie Lebensmittel und erkennen Sie Allergene in Sekunden',
      heroSubtitle: 'Kostenlos. Schnell. Ohne Registrierung.',
      installOnMobile: 'Auf dem Handy installieren',
      whatItDoes: 'Was macht die App',
      scanBarcodes: 'Barcodes scannen',
      identifyAllergens: 'Allergene automatisch identifizieren',
      customList: 'Personalisierte Liste Ihrer Allergien',
      worksPWA: 'Funktioniert als PWA (ohne Play Store installierbar)',
      realScreenshots: 'Echte Screenshots',
      closeLanding: 'Schließen',
      contribute: 'Beitragen',
      comingSoon: 'Demnächst',
      startNow: 'Jetzt starten',
      joinThousands: 'Schließen Sie sich Tausenden von Familien an, die unsere App bereits für ein ruhigeres Leben nutzen',
      scanScreen: 'Scan-Bildschirm',
      productResult: 'Produktergebnis',
      allergenSelection: 'Allergenauswahl',
      
      // PWA Install Instructions
      installInstructions: 'Auf Ihrem Gerät installieren',
      alreadyInstalled: 'Die App ist bereits installiert!',
      appInstalled: 'App erfolgreich installiert!',
      iosInstallTitle: 'Zum Installieren auf iPhone/iPad:',
      iosStep1: 'Tippen Sie auf die Teilen-Schaltfläche',
      iosStep2: 'Nach unten scrollen und "Zum Home-Bildschirm" tippen',
      iosStep3: 'Oben rechts auf "Hinzufügen" tippen',
      androidInstallTitle: 'Zum Installieren:',
      androidStep1: 'Öffnen Sie das Browser-Menü (⋮)',
      androidStep2: 'Wählen Sie "App installieren" oder "Zum Startbildschirm hinzufügen"',
      androidStep3: 'Bestätigen Sie die Installation',
      continueToApp: 'Zur App fortfahren',
      
      benefits: 'Vorteile',
      benefitAllergies: 'Ideal für Menschen mit Allergien',
      benefitParents: 'Perfekt für Mütter/Väter mit Kindern mit Unverträglichkeiten oder Allergien',
      benefitSupermarket: 'Nützlich im Supermarkt',
      benefitNoReading: 'Vermeiden Sie das Lesen komplizierter Zutaten und Zusatzstoffe',
      
      // Privacy Policy
      privacyPolicy: 'Datenschutzerklärung',
      privacyLastUpdated: 'Letzte Aktualisierung',
      privacyIntro: 'Bei Allergen Detektor nehmen wir den Datenschutz unserer Nutzer sehr ernst. Diese Richtlinie beschreibt, welche Informationen wir sammeln, wie wir sie verwenden und welche Rechte Sie an Ihren Daten haben.',
      privacyDataCollected: 'Daten, die wir sammeln',
      privacyDataCollectedDesc: 'Wir sammeln die folgenden Informationen, um unsere Dienste bereitzustellen und zu verbessern:',
      privacyDataItem1: 'Allergen-Einstellungen: Die Allergene, die Sie zur Überwachung auswählen',
      privacyDataItem2: 'Scan-Verlauf: Die Barcodes, die Sie scannen (mit einer anonymen ID verknüpft)',
      privacyDataItem3: 'Lieblingsprodukte: Die Produkte, die Sie als Favoriten speichern',
      privacyDataItem4: 'Allergen-Profile: Die Profile, die Sie für verschiedene Personen erstellen',
      privacyDataItem5: 'Anonyme Benutzer-ID: Eine lokal generierte eindeutige Kennung (UUID) zur Zuordnung Ihrer Daten',
      privacyHowWeUse: 'Wie wir Ihre Daten verwenden',
      privacyHowWeUseDesc: 'Wir verwenden Ihre Daten ausschließlich um:',
      privacyUseItem1: 'Produkte zu analysieren und Allergene gemäß Ihren Einstellungen zu erkennen',
      privacyUseItem2: 'Ihre Präferenzen und Favoriten zu speichern',
      privacyUseItem3: 'Ihnen sichere alternative Produkte vorzuschlagen',
      privacyUseItem4: 'Die App-Erfahrung zu verbessern',
      privacyNoShare: 'Wir teilen Ihre Daten nicht',
      privacyNoShareDesc: 'Ihre Daten werden niemals verkauft oder mit Dritten geteilt. Die Informationen werden sicher gespeichert und nur für die App-Funktionalität verwendet.',
      privacyRights: 'Ihre Rechte',
      privacyRightsDesc: 'Sie haben das Recht:',
      privacyRightItem1: 'Auf Ihre gespeicherten Daten zuzugreifen',
      privacyRightItem2: 'Ihre Daten jederzeit zu löschen',
      privacyRightItem3: 'Ihre Daten zu exportieren',
      privacyRightItem4: 'Zugriffsberechtigungen zu widerrufen',
      privacyContact: 'Kontakt',
      privacyContactDesc: 'Bei Fragen zu dieser Datenschutzerklärung können Sie uns kontaktieren unter:',
      privacyCookies: 'Cookies und lokaler Speicher',
      privacyCookiesDesc: 'Wir verwenden localStorage, um Ihre anonyme Benutzer-ID und Präferenzen zu speichern. Wir verwenden keine Tracking-Cookies von Drittanbietern.',
      privacyChanges: 'Änderungen dieser Richtlinie',
      privacyChangesDesc: 'Wir können diese Richtlinie gelegentlich aktualisieren. Wir werden Sie über wesentliche Änderungen über die App informieren.'
    }
  },
  ca: {
    translation: {
      welcomeMessage: welcomeMessage.ca,
      appTitle: 'Detector d\'Al·lèrgens',
      appInfo: 'Informació de l\'App',
      favorites: 'Favorits',
      profiles: 'Perfils',
      suggestions: 'Suggeriments',
      scanBarcode: 'Escanejar',
      myAllergens: 'Els Meus Al·lèrgens',
      scanProduct: 'Escanejar Producte',
      enterBarcode: 'Introdueix el codi',
      barcodePlaceholder: 'Ex: 8480000123456',
      search: 'Cercar',
      startScanning: 'Iniciar',
      stopScanning: 'Aturar',
      configureAllergens: 'Configurar',
      selectAllergens: 'Selecciona els al·lèrgens',
      saveConfiguration: 'Guardar',
      configSaved: 'Configurat',
      safeToConsume: '✓ Segur',
      containsAllergens: '⚠ Conté al·lèrgens',
      productNotFound: 'No trobat',
      productNotFoundDesc: 'No hi ha informació',
      ingredients: 'Ingredients',
      allergenDetected: 'Al·lèrgen detectat',
      foundIn: 'Trobat en',
      additives: 'Additius',
      brands: 'Marques',
      noAllergensConfigured: 'No configurat',
      configureFirst: 'Configura primer',
      goToConfig: 'Configuració',
      
      dairy: 'Làctics',
      lactose: 'Lactosa',
      gluten: 'Gluten',
      egg: 'Ou',
      fish: 'Peix',
      soy: 'Soja',
      nuts: 'Fruits Secs',
      shellfish: 'Marisc',
      sulfites: 'Sulfits',
      celery: 'Api',
      mustard: 'Mostassa',
      sesame: 'Sèsam',
      lupins: 'Tramús',
      
      suggestionBox: 'Bústia de Suggeriments',
      suggestionBoxDesc: 'Comparteix els teus comentaris',
      yourName: 'El teu nom (opcional)',
      yourEmail: 'El teu email (opcional)',
      yourMessage: 'El teu missatge',
      messagePlaceholder: 'Escriu aquí...',
      sendSuggestion: 'Enviar',
      suggestionSent: 'Missatge enviat!',
      thankYouFeedback: 'Gràcies pel feedback',
      messageRequired: 'Missatge requerit',
      close: 'Tancar',
      showWelcome: 'Veure missatge de benvinguda',
      
      myFavorites: 'Els Meus Favorits',
      noFavoritesYet: 'Encara no hi ha favorits',
      addToFavorites: 'Afegir a favorits',
      removeFromFavorites: 'Treure de favorits',
      addedToFavorites: 'Afegit a favorits',
      favoritesRequiresUpgrade: 'Has arribat al límit de 3 favorits gratis. Activa Premium o codi Beta per il·limitats.',
      errorSavingFavorite: 'Error en guardar favorit',
      removedFromFavorites: 'Eliminat de favorits',
      scanHistory: 'Historial d\'escanejos',
      noHistoryYet: 'Encara no has escanejat cap producte',
      clearHistory: 'Esborrar tot',
      confirmClearHistory: 'Esborrar tot l\'historial?',
      
      allergenProfiles: 'Perfils d\'Al·lèrgens',
      saveAsProfile: 'Guardar com a Perfil',
      profileName: 'Nom del perfil',
      profileNamePlaceholder: 'Ex: Perfil de Maria',
      saveProfile: 'Guardar',
      loadProfile: 'Carregar',
      deleteProfile: 'Eliminar',
      profileSaved: 'Perfil guardat',
      profileLoaded: 'Perfil carregat',
      profileDeleted: 'Perfil eliminat',
      noProfilesYet: 'No hi ha perfils',
      profileNameRequired: 'Nom requerit',
      
      suggestedProducts: 'Productes Suggerits',
      safeDairyFree: 'Segur - Sense làctics',
      safeAlternative: 'Alternativa segura',
      
      addCustomAllergen: 'Afegir Al·lèrgen Personalitzat',
      allergenName: 'Nom de l\'al·lèrgen',
      keywords: 'Paraules clau (separades per coma)',
      customAdditives: 'Additius (ex: E270, E322)',
      suggestAllergen: 'Suggerir Al·lèrgen',
      suggestAllergenDesc: 'No trobes un al·lèrgen? Envia\'ns el teu suggeriment a allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Suggeriment d\'al·lèrgen enviat',
      
      heroTitle: 'Escaneja aliments i detecta al·lèrgens en segons',
      heroSubtitle: 'Gratis. Ràpid. Sense registre.',
      installOnMobile: 'Instal·lar al mòbil',
      whatItDoes: 'Què fa l\'app',
      scanBarcodes: 'Escaneja codis de barres',
      identifyAllergens: 'Identifica al·lèrgens automàticament',
      customList: 'Llista personalitzada de les teves al·lèrgies',
      worksPWA: 'Funciona com a PWA (instal·lable sense Play Store)',
      realScreenshots: 'Captures reals',
      closeLanding: 'Tancar',
      contribute: 'Contribuir',
      comingSoon: 'Properament',
      startNow: 'Comença ara',
      joinThousands: 'Uneix-te a milers de famílies que ja fan servir la nostra app per viure més tranquil·les',
      scanScreen: 'Pantalla d\'escaneig',
      productResult: 'Resultat del producte',
      allergenSelection: 'Selecció d\'al·lèrgens',
      
      // PWA Install Instructions
      installInstructions: 'Instal·lar al teu dispositiu',
      alreadyInstalled: 'L\'app ja està instal·lada!',
      appInstalled: 'App instal·lada correctament!',
      iosInstallTitle: 'Per instal·lar a iPhone/iPad:',
      iosStep1: 'Toca el botó de compartir',
      iosStep2: 'Desplaça cap avall i toca "Afegir a la pantalla d\'inici"',
      iosStep3: 'Toca "Afegir" a la cantonada superior dreta',
      androidInstallTitle: 'Per instal·lar:',
      androidStep1: 'Obre el menú del navegador (⋮)',
      androidStep2: 'Selecciona "Instal·lar aplicació" o "Afegir a la pantalla d\'inici"',
      androidStep3: 'Confirma la instal·lació',
      continueToApp: 'Continuar a l\'app',
      
      benefits: 'Beneficis',
      benefitAllergies: 'Ideal per a persones amb al·lèrgies',
      benefitParents: 'Perfecte per a mares/pares amb fills amb intoleràncies o al·lèrgies',
      benefitSupermarket: 'Útil al supermercat',
      benefitNoReading: 'Evita llegir ingredients i additius complicats',
      
      // Privacy Policy
      privacyPolicy: 'Política de Privacitat',
      privacyLastUpdated: 'Última actualització',
      privacyIntro: 'A Detector d\'Al·lèrgens, ens prenem molt seriosament la privacitat dels nostres usuaris. Aquesta política descriu quina informació recopilem, com la fem servir i els drets que tens sobre les teves dades.',
      privacyDataCollected: 'Dades que recopilem',
      privacyDataCollectedDesc: 'Recopilem la següent informació per proporcionar i millorar els nostres serveis:',
      privacyDataItem1: 'Configuració d\'al·lèrgens: Els al·lèrgens que selecciones per monitorar',
      privacyDataItem2: 'Historial d\'escanejos: Els codis de barres que escaneges (vinculats a un ID anònim)',
      privacyDataItem3: 'Productes favorits: Els productes que guardes com a favorits',
      privacyDataItem4: 'Perfils d\'al·lèrgens: Els perfils que crees per a diferents persones',
      privacyDataItem5: 'ID d\'usuari anònim: Un identificador únic generat localment (UUID) per associar les teves dades',
      privacyHowWeUse: 'Com fem servir les teves dades',
      privacyHowWeUseDesc: 'Utilitzem les teves dades exclusivament per:',
      privacyUseItem1: 'Analitzar productes i detectar al·lèrgens segons la teva configuració',
      privacyUseItem2: 'Guardar les teves preferències i favorits',
      privacyUseItem3: 'Suggerir-te productes alternatius segurs',
      privacyUseItem4: 'Millorar l\'experiència de l\'aplicació',
      privacyNoShare: 'No compartim les teves dades',
      privacyNoShareDesc: 'Les teves dades mai es venen ni es comparteixen amb tercers. La informació s\'emmagatzema de forma segura i només s\'utilitza per al funcionament de l\'app.',
      privacyRights: 'Els teus drets',
      privacyRightsDesc: 'Tens dret a:',
      privacyRightItem1: 'Accedir a les teves dades emmagatzemades',
      privacyRightItem2: 'Eliminar les teves dades en qualsevol moment',
      privacyRightItem3: 'Exportar les teves dades',
      privacyRightItem4: 'Revocar permisos d\'accés',
      privacyContact: 'Contacte',
      privacyContactDesc: 'Si tens preguntes sobre aquesta política de privacitat, pots contactar-nos a:',
      privacyCookies: 'Cookies i emmagatzematge local',
      privacyCookiesDesc: 'Utilitzem localStorage per guardar el teu ID d\'usuari anònim i preferències. No utilitzem cookies de seguiment de tercers.',
      privacyChanges: 'Canvis en aquesta política',
      privacyChangesDesc: 'Podem actualitzar aquesta política ocasionalment. Et notificarem qualsevol canvi significatiu a través de l\'aplicació.'
    }
  },
  eu: {
    translation: {
      welcomeMessage: welcomeMessage.eu,
      appTitle: 'Alergenoen Detektagailua',
      appInfo: 'Aplikazioaren Informazioa',
      favorites: 'Gogokoak',
      profiles: 'Profilak',
      suggestions: 'Iradokizunak',
      scanBarcode: 'Eskaneatu',
      myAllergens: 'Nire Alergenoak',
      scanProduct: 'Produktua Eskaneatu',
      enterBarcode: 'Sartu kodea',
      barcodePlaceholder: 'Ad: 8480000123456',
      search: 'Bilatu',
      startScanning: 'Hasi',
      stopScanning: 'Gelditu',
      configureAllergens: 'Konfiguratu',
      selectAllergens: 'Hautatu alergenoak',
      saveConfiguration: 'Gorde',
      configSaved: 'Gordeta',
      safeToConsume: '✓ Segurua',
      containsAllergens: '⚠ Alergenoak ditu',
      productNotFound: 'Ez aurkitua',
      productNotFoundDesc: 'Ez dago informaziorik',
      ingredients: 'Osagaiak',
      allergenDetected: 'Alergenoa detektatu da',
      foundIn: 'Aurkitua hemen',
      additives: 'Gehigarriak',
      brands: 'Markak',
      noAllergensConfigured: 'Ez konfiguratu',
      configureFirst: 'Konfiguratu lehenik',
      goToConfig: 'Konfiguraziora',
      
      dairy: 'Esnekiak',
      lactose: 'Laktosa',
      gluten: 'Glutena',
      egg: 'Arrautza',
      fish: 'Arraina',
      soy: 'Soja',
      nuts: 'Fruitu Lehorrak',
      shellfish: 'Itsaskiak',
      sulfites: 'Sulfitoak',
      celery: 'Apio',
      mustard: 'Ziape',
      sesame: 'Sesamo',
      lupins: 'Altramuzak',
      
      suggestionBox: 'Iradokizun Kutxa',
      suggestionBoxDesc: 'Partekatu zure iritziak',
      yourName: 'Zure izena (aukerakoa)',
      yourEmail: 'Zure emaila (aukerakoa)',
      yourMessage: 'Zure mezua',
      messagePlaceholder: 'Idatzi hemen...',
      sendSuggestion: 'Bidali',
      suggestionSent: 'Mezua bidali da!',
      thankYouFeedback: 'Eskerrik asko',
      messageRequired: 'Mezua beharrezkoa da',
      close: 'Itxi',
      
      myFavorites: 'Nire Gogokoak',
      noFavoritesYet: 'Oraindik ez dago gogokorik',
      addToFavorites: 'Gogokoetara gehitu',
      removeFromFavorites: 'Gogokoetatik kendu',
      addedToFavorites: 'Gogokoetara gehituta',
      removedFromFavorites: 'Gogokoetatik kenduta',
      scanHistory: 'Eskaneo-historia',
      noHistoryYet: 'Oraindik ez duzu produkturik eskaneatu',
      clearHistory: 'Garbitu dena',
      confirmClearHistory: 'Historia osoa ezabatu?',
      
      allergenProfiles: 'Alergeno Profilak',
      saveAsProfile: 'Profil gisa gorde',
      profileName: 'Profilaren izena',
      profileNamePlaceholder: 'Ad: Mariaren profila',
      saveProfile: 'Gorde',
      loadProfile: 'Kargatu',
      deleteProfile: 'Ezabatu',
      profileSaved: 'Profila gordeta',
      profileLoaded: 'Profila kargatuta',
      profileDeleted: 'Profila ezabatuta',
      noProfilesYet: 'Ez dago profilik',
      profileNameRequired: 'Izena beharrezkoa',
      
      suggestedProducts: 'Iradokitako Produktuak',
      safeDairyFree: 'Segurua - Esnekirik gabe',
      safeAlternative: 'Alternatiba segurua',
      
      addCustomAllergen: 'Alergeno Pertsonalizatua Gehitu',
      allergenName: 'Alergenoaren izena',
      keywords: 'Gako-hitzak (komaz banatuta)',
      customAdditives: 'Gehigarriak (ad: E270, E322)',
      suggestAllergen: 'Alergenoa Iradoki',
      suggestAllergenDesc: 'Ez duzu alergenorik aurkitzen? Bidali zure iradokizuna allergenapp.mail@gmail.com helbidera',
      allergenSuggestionSent: 'Alergeno iradokizuna bidalita',
      
      heroTitle: 'Eskaneatu janaria eta detektatu alergenoak segundutan',
      heroSubtitle: 'Doan. Azkarra. Erregistrorik gabe.',
      installOnMobile: 'Mugikorrean instalatu',
      whatItDoes: 'Zer egiten du aplikazioak',
      scanBarcodes: 'Barra-kodeak eskaneatu',
      identifyAllergens: 'Alergenoak automatikoki identifikatu',
      customList: 'Zure alergien zerrenda pertsonalizatua',
      worksPWA: 'PWA gisa funtzionatzen du (Play Store gabe instalagarria)',
      realScreenshots: 'Benetako argazkiak',
      closeLanding: 'Itxi',
      contribute: 'Lagundu',
      comingSoon: 'Laster',
      startNow: 'Hasi orain',
      joinThousands: 'Bat egin gure aplikazioa lasaiago bizitzeko dagoeneko erabiltzen duten milaka familiarekin',
      scanScreen: 'Eskaneatze pantaila',
      productResult: 'Produktuaren emaitza',
      allergenSelection: 'Alergeno hautaketa',
      
      // PWA Install Instructions
      installInstructions: 'Instalatu zure gailuan',
      alreadyInstalled: 'Aplikazioa dagoeneko instalatuta dago!',
      appInstalled: 'Aplikazioa behar bezala instalatuta!',
      iosInstallTitle: 'iPhone/iPad-en instalatzeko:',
      iosStep1: 'Sakatu partekatzeko botoia',
      iosStep2: 'Behera mugitu eta sakatu "Hasierako pantailara gehitu"',
      iosStep3: 'Sakatu "Gehitu" goiko eskuineko izkinan',
      androidInstallTitle: 'Instalatzeko:',
      androidStep1: 'Ireki nabigatzailearen menua (⋮)',
      androidStep2: 'Hautatu "Instalatu aplikazioa" edo "Hasierako pantailara gehitu"',
      androidStep3: 'Berretsi instalazioa',
      continueToApp: 'Jarraitu aplikaziora',
      
      benefits: 'Onurak',
      benefitAllergies: 'Alergia duten pertsonentzat ideala',
      benefitParents: 'Intolerantziak edo alergiak dituzten seme-alabak dituzten ama/aita perfektua',
      benefitSupermarket: 'Erabilgarria supermerkatuan',
      benefitNoReading: 'Saihestu osagai eta gehigarri korapilatsuak irakurtzea',
      
      // Privacy Policy
      privacyPolicy: 'Pribatutasun Politika',
      privacyLastUpdated: 'Azken eguneratzea',
      privacyIntro: 'Alergeno Detektorean, gure erabiltzaileen pribatutasuna oso serio hartzen dugu. Politika honek zein informazio biltzen dugun, nola erabiltzen dugun eta zure datuei buruzko eskubideak azaltzen ditu.',
      privacyDataCollected: 'Biltzen ditugun datuak',
      privacyDataCollectedDesc: 'Informazio hau biltzen dugu gure zerbitzuak emateko eta hobetzeko:',
      privacyDataItem1: 'Alergeno ezarpenak: Monitorizatzeko hautatzen dituzun alergenoak',
      privacyDataItem2: 'Eskaneatu historiala: Eskaneatzen dituzun barra-kodeak (ID anonimo batekin lotuta)',
      privacyDataItem3: 'Gogoko produktuak: Gogoko gisa gordetzen dituzun produktuak',
      privacyDataItem4: 'Alergeno profilak: Pertsona ezberdinentzat sortzen dituzun profilak',
      privacyDataItem5: 'Erabiltzaile ID anonimoa: Zure datuak lotzeko lokalki sortutako identifikatzaile bakarra (UUID)',
      privacyHowWeUse: 'Nola erabiltzen ditugun zure datuak',
      privacyHowWeUseDesc: 'Zure datuak soilik hauetarako erabiltzen ditugu:',
      privacyUseItem1: 'Produktuak aztertu eta alergenoak detektatu zure ezarpenen arabera',
      privacyUseItem2: 'Zure lehentasunak eta gogokoak gorde',
      privacyUseItem3: 'Ordezko produktu seguruak iradoki',
      privacyUseItem4: 'Aplikazioaren esperientzia hobetu',
      privacyNoShare: 'Ez ditugu zure datuak partekatzen',
      privacyNoShareDesc: 'Zure datuak ez dira inoiz saltzen edo hirugarrenekin partekatzen. Informazioa modu seguruan gordetzen da eta soilik aplikazioaren funtzionamendurako erabiltzen da.',
      privacyRights: 'Zure eskubideak',
      privacyRightsDesc: 'Eskubidea duzu:',
      privacyRightItem1: 'Gordetako datuetara sartzeko',
      privacyRightItem2: 'Zure datuak edozein unetan ezabatzeko',
      privacyRightItem3: 'Zure datuak esportatzeko',
      privacyRightItem4: 'Sarbide baimenak baliogabetzeko',
      privacyContact: 'Kontaktua',
      privacyContactDesc: 'Pribatutasun politika honi buruzko galderarik baduzu, hemen jar zaitezke gurekin harremanetan:',
      privacyCookies: 'Cookieak eta tokiko biltegiratzea',
      privacyCookiesDesc: 'localStorage erabiltzen dugu zure erabiltzaile ID anonimoa eta lehentasunak gordetzeko. Ez ditugu hirugarrenen jarraipen cookieak erabiltzen.',
      privacyChanges: 'Politika honen aldaketak',
      privacyChangesDesc: 'Politika hau noizean behin egunera dezakegu. Aldaketa garrantzitsuez aplikazioaren bidez jakinaraziko dizugu.'
    }
  },
  gl: {
    translation: {
      welcomeMessage: welcomeMessage.gl,
      appTitle: 'Detector de Alerxenos',
      appInfo: 'Información da App',
      favorites: 'Favoritos',
      profiles: 'Perfís',
      suggestions: 'Suxestións',
      scanBarcode: 'Escanear',
      myAllergens: 'Os Meus Alerxenos',
      scanProduct: 'Escanear Produto',
      enterBarcode: 'Introduce o código',
      barcodePlaceholder: 'Ex: 8480000123456',
      search: 'Buscar',
      startScanning: 'Iniciar',
      stopScanning: 'Deter',
      configureAllergens: 'Configurar',
      selectAllergens: 'Selecciona os alerxenos',
      saveConfiguration: 'Gardar',
      configSaved: 'Gardado',
      safeToConsume: '✓ Seguro',
      containsAllergens: '⚠ Contén alerxenos',
      productNotFound: 'Non atopado',
      productNotFoundDesc: 'Non hai información',
      ingredients: 'Ingredientes',
      allergenDetected: 'Alerxeno detectado',
      foundIn: 'Atopado en',
      additives: 'Aditivos',
      brands: 'Marcas',
      noAllergensConfigured: 'Non configurado',
      configureFirst: 'Configura primeiro',
      goToConfig: 'Configuración',
      
      dairy: 'Lácteos',
      lactose: 'Lactosa',
      gluten: 'Glute',
      egg: 'Ovo',
      fish: 'Peixe',
      soy: 'Soia',
      nuts: 'Froitos Secos',
      shellfish: 'Mariscos',
      sulfites: 'Sulfitos',
      celery: 'Apio',
      mustard: 'Mostaza',
      sesame: 'Sésamo',
      lupins: 'Altramuz',
      
      suggestionBox: 'Buzón de Suxestións',
      suggestionBoxDesc: 'Comparte os teus comentarios',
      yourName: 'O teu nome (opcional)',
      yourEmail: 'O teu email (opcional)',
      yourMessage: 'A túa mensaxe',
      messagePlaceholder: 'Escribe aquí...',
      sendSuggestion: 'Enviar',
      suggestionSent: 'Mensaxe enviada!',
      thankYouFeedback: 'Grazas polo feedback',
      messageRequired: 'Mensaxe requirida',
      close: 'Pechar',
      
      myFavorites: 'Os Meus Favoritos',
      noFavoritesYet: 'Aínda non hai favoritos',
      addToFavorites: 'Engadir a favoritos',
      removeFromFavorites: 'Quitar de favoritos',
      addedToFavorites: 'Engadido a favoritos',
      removedFromFavorites: 'Eliminado de favoritos',
      scanHistory: 'Historial de escaneos',
      noHistoryYet: 'Aínda non escaneaches ningún produto',
      clearHistory: 'Borrar todo',
      confirmClearHistory: 'Borrar todo o historial?',
      
      allergenProfiles: 'Perfís de Alerxenos',
      saveAsProfile: 'Gardar como Perfil',
      profileName: 'Nome do perfil',
      profileNamePlaceholder: 'Ex: Perfil de María',
      saveProfile: 'Gardar',
      loadProfile: 'Cargar',
      deleteProfile: 'Eliminar',
      profileSaved: 'Perfil gardado',
      profileLoaded: 'Perfil cargado',
      profileDeleted: 'Perfil eliminado',
      noProfilesYet: 'Non hai perfís',
      profileNameRequired: 'Nome requirido',
      
      suggestedProducts: 'Produtos Suxeridos',
      safeDairyFree: 'Seguro - Sen lácteos',
      safeAlternative: 'Alternativa segura',
      
      addCustomAllergen: 'Engadir Alerxeno Personalizado',
      allergenName: 'Nome do alerxeno',
      keywords: 'Palabras clave (separadas por coma)',
      customAdditives: 'Aditivos (ex: E270, E322)',
      suggestAllergen: 'Suxerir Alerxeno',
      suggestAllergenDesc: 'Non atopas un alerxeno? Envíanos a túa suxestión a allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Suxestión de alerxeno enviada',
      
      heroTitle: 'Escanea alimentos e detecta alerxenos en segundos',
      heroSubtitle: 'Gratis. Rápido. Sen rexistro.',
      installOnMobile: 'Instalar no móbil',
      whatItDoes: 'Que fai a app',
      scanBarcodes: 'Escanea códigos de barras',
      identifyAllergens: 'Identifica alerxenos automaticamente',
      customList: 'Lista personalizada das túas alerxias',
      worksPWA: 'Funciona como PWA (instalable sen Play Store)',
      realScreenshots: 'Capturas reais',
      closeLanding: 'Pechar',
      contribute: 'Contribuír',
      comingSoon: 'Proximamente',
      startNow: 'Comeza agora',
      joinThousands: 'Únete a miles de familias que xa usan a nosa app para vivir máis tranquilas',
      scanScreen: 'Pantalla de escaneo',
      productResult: 'Resultado do alimento',
      allergenSelection: 'Selección de alerxenos',
      
      // PWA Install Instructions
      installInstructions: 'Instalar no teu dispositivo',
      alreadyInstalled: 'A app xa está instalada!',
      appInstalled: 'App instalada correctamente!',
      iosInstallTitle: 'Para instalar en iPhone/iPad:',
      iosStep1: 'Toca o botón de compartir',
      iosStep2: 'Desprázate cara abaixo e toca "Engadir á pantalla de inicio"',
      iosStep3: 'Toca "Engadir" na esquina superior dereita',
      androidInstallTitle: 'Para instalar:',
      androidStep1: 'Abre o menú do navegador (⋮)',
      androidStep2: 'Selecciona "Instalar aplicación" ou "Engadir á pantalla de inicio"',
      androidStep3: 'Confirma a instalación',
      continueToApp: 'Continuar á app',
      
      benefits: 'Beneficios',
      benefitAllergies: 'Ideal para persoas con alerxias',
      benefitParents: 'Perfecto para nais/pais con fillos con intolerancias ou alerxias',
      benefitSupermarket: 'Útil no supermercado',
      benefitNoReading: 'Evita ler ingredientes e aditivos complicados',
      
      // Privacy Policy
      privacyPolicy: 'Política de Privacidade',
      privacyLastUpdated: 'Última actualización',
      privacyIntro: 'En Detector de Alerxenos, tomamos moi en serio a privacidade dos nosos usuarios. Esta política describe que información recompilamos, como a usamos e os dereitos que tes sobre os teus datos.',
      privacyDataCollected: 'Datos que recompilamos',
      privacyDataCollectedDesc: 'Recompilamos a seguinte información para proporcionar e mellorar os nosos servizos:',
      privacyDataItem1: 'Configuración de alerxenos: Os alerxenos que seleccionas para monitorizar',
      privacyDataItem2: 'Historial de escaneos: Os códigos de barras que escaneas (vinculados a un ID anónimo)',
      privacyDataItem3: 'Produtos favoritos: Os produtos que gardas como favoritos',
      privacyDataItem4: 'Perfís de alerxenos: Os perfís que creas para diferentes persoas',
      privacyDataItem5: 'ID de usuario anónimo: Un identificador único xerado localmente (UUID) para asociar os teus datos',
      privacyHowWeUse: 'Como usamos os teus datos',
      privacyHowWeUseDesc: 'Utilizamos os teus datos exclusivamente para:',
      privacyUseItem1: 'Analizar produtos e detectar alerxenos segundo a túa configuración',
      privacyUseItem2: 'Gardar as túas preferencias e favoritos',
      privacyUseItem3: 'Suxerirche produtos alternativos seguros',
      privacyUseItem4: 'Mellorar a experiencia da aplicación',
      privacyNoShare: 'Non compartimos os teus datos',
      privacyNoShareDesc: 'Os teus datos nunca se venden nin se comparten con terceiros. A información almacénase de forma segura e só se utiliza para o funcionamento da app.',
      privacyRights: 'Os teus dereitos',
      privacyRightsDesc: 'Tes dereito a:',
      privacyRightItem1: 'Acceder aos teus datos almacenados',
      privacyRightItem2: 'Eliminar os teus datos en calquera momento',
      privacyRightItem3: 'Exportar os teus datos',
      privacyRightItem4: 'Revogar permisos de acceso',
      privacyContact: 'Contacto',
      privacyContactDesc: 'Se tes preguntas sobre esta política de privacidade, podes contactarnos en:',
      privacyCookies: 'Cookies e almacenamento local',
      privacyCookiesDesc: 'Utilizamos localStorage para gardar o teu ID de usuario anónimo e preferencias. Non utilizamos cookies de seguimento de terceiros.',
      privacyChanges: 'Cambios nesta política',
      privacyChangesDesc: 'Podemos actualizar esta política ocasionalmente. Notificarémosche calquera cambio significativo a través da aplicación.'
    }
  },
  it: {
    translation: {
      welcomeMessage: welcomeMessage.it,
      appTitle: 'Rilevatore di Allergeni',
      appInfo: 'Informazioni sull\'App',
      favorites: 'Preferiti',
      profiles: 'Profili',
      suggestions: 'Suggerimenti',
      scanBarcode: 'Scansiona',
      myAllergens: 'I Miei Allergeni',
      scanProduct: 'Scansiona Prodotto',
      enterBarcode: 'Inserisci il codice',
      barcodePlaceholder: 'Es: 8480000123456',
      search: 'Cerca',
      startScanning: 'Avvia',
      stopScanning: 'Ferma',
      configureAllergens: 'Configura',
      selectAllergens: 'Seleziona gli allergeni',
      saveConfiguration: 'Salva',
      configSaved: 'Salvato',
      safeToConsume: '✓ Sicuro',
      containsAllergens: '⚠ Contiene allergeni',
      productNotFound: 'Non trovato',
      productNotFoundDesc: 'Nessuna informazione',
      ingredients: 'Ingredienti',
      allergenDetected: 'Allergene rilevato',
      foundIn: 'Trovato in',
      additives: 'Additivi',
      brands: 'Marche',
      noAllergensConfigured: 'Non configurato',
      configureFirst: 'Configura prima',
      goToConfig: 'Configurazione',
      
      dairy: 'Latticini',
      lactose: 'Lattosio',
      gluten: 'Glutine',
      egg: 'Uovo',
      fish: 'Pesce',
      soy: 'Soia',
      nuts: 'Frutta Secca',
      shellfish: 'Crostacei',
      sulfites: 'Solfiti',
      celery: 'Sedano',
      mustard: 'Senape',
      sesame: 'Sesamo',
      lupins: 'Lupini',
      
      suggestionBox: 'Casella Suggerimenti',
      suggestionBoxDesc: 'Condividi i tuoi commenti',
      yourName: 'Il tuo nome (facoltativo)',
      yourEmail: 'La tua email (facoltativo)',
      yourMessage: 'Il tuo messaggio',
      messagePlaceholder: 'Scrivi qui...',
      sendSuggestion: 'Invia',
      suggestionSent: 'Messaggio inviato!',
      thankYouFeedback: 'Grazie per il feedback',
      messageRequired: 'Messaggio richiesto',
      close: 'Chiudi',
      
      myFavorites: 'I Miei Preferiti',
      noFavoritesYet: 'Nessun preferito ancora',
      addToFavorites: 'Aggiungi ai preferiti',
      removeFromFavorites: 'Rimuovi dai preferiti',
      addedToFavorites: 'Aggiunto ai preferiti',
      removedFromFavorites: 'Rimosso dai preferiti',
      scanHistory: 'Cronologia scansioni',
      noHistoryYet: 'Nessun prodotto scansionato ancora',
      clearHistory: 'Cancella tutto',
      confirmClearHistory: 'Cancellare tutta la cronologia?',
      
      allergenProfiles: 'Profili Allergeni',
      saveAsProfile: 'Salva come Profilo',
      profileName: 'Nome del profilo',
      profileNamePlaceholder: 'Es: Profilo di Maria',
      saveProfile: 'Salva',
      loadProfile: 'Carica',
      deleteProfile: 'Elimina',
      profileSaved: 'Profilo salvato',
      profileLoaded: 'Profilo caricato',
      profileDeleted: 'Profilo eliminato',
      noProfilesYet: 'Nessun profilo',
      profileNameRequired: 'Nome richiesto',
      
      suggestedProducts: 'Prodotti Suggeriti',
      safeDairyFree: 'Sicuro - Senza lattosio',
      safeAlternative: 'Alternativa sicura',
      
      addCustomAllergen: 'Aggiungi Allergene Personalizzato',
      allergenName: 'Nome dell\'allergene',
      keywords: 'Parole chiave (separate da virgola)',
      customAdditives: 'Additivi (es: E270, E322)',
      suggestAllergen: 'Suggerisci Allergene',
      suggestAllergenDesc: 'Non trovi un allergene? Inviaci il tuo suggerimento a allergenapp.mail@gmail.com',
      allergenSuggestionSent: 'Suggerimento allergene inviato',
      
      heroTitle: 'Scansiona alimenti e rileva allergeni in secondi',
      heroSubtitle: 'Gratuito. Veloce. Senza registrazione.',
      installOnMobile: 'Installa sul cellulare',
      whatItDoes: 'Cosa fa l\'app',
      scanBarcodes: 'Scansiona codici a barre',
      identifyAllergens: 'Identifica automaticamente gli allergeni',
      customList: 'Lista personalizzata delle tue allergie',
      worksPWA: 'Funziona come PWA (installabile senza Play Store)',
      realScreenshots: 'Screenshot reali',
      closeLanding: 'Chiudi',
      contribute: 'Contribuisci',
      comingSoon: 'Prossimamente',
      startNow: 'Inizia ora',
      joinThousands: 'Unisciti a migliaia di famiglie che già usano la nostra app per vivere più serenamente',
      scanScreen: 'Schermata di scansione',
      productResult: 'Risultato del prodotto',
      allergenSelection: 'Selezione allergeni',
      
      // PWA Install Instructions
      installInstructions: 'Installa sul tuo dispositivo',
      alreadyInstalled: 'L\'app è già installata!',
      appInstalled: 'App installata con successo!',
      iosInstallTitle: 'Per installare su iPhone/iPad:',
      iosStep1: 'Tocca il pulsante condividi',
      iosStep2: 'Scorri verso il basso e tocca "Aggiungi a Home"',
      iosStep3: 'Tocca "Aggiungi" nell\'angolo in alto a destra',
      androidInstallTitle: 'Per installare:',
      androidStep1: 'Apri il menu del browser (⋮)',
      androidStep2: 'Seleziona "Installa app" o "Aggiungi a schermata Home"',
      androidStep3: 'Conferma l\'installazione',
      continueToApp: 'Continua all\'app',
      
      benefits: 'Benefici',
      benefitAllergies: 'Ideale per persone con allergie',
      benefitParents: 'Perfetto per mamme/papà con bambini con intolleranze o allergie',
      benefitSupermarket: 'Utile al supermercato',
      benefitNoReading: 'Evita di leggere ingredienti e additivi complicati',
      
      // Privacy Policy
      privacyPolicy: 'Informativa sulla Privacy',
      privacyLastUpdated: 'Ultimo aggiornamento',
      privacyIntro: 'In Rilevatore di Allergeni, prendiamo molto sul serio la privacy dei nostri utenti. Questa informativa descrive quali informazioni raccogliamo, come le utilizziamo e i diritti che hai sui tuoi dati.',
      privacyDataCollected: 'Dati che raccogliamo',
      privacyDataCollectedDesc: 'Raccogliamo le seguenti informazioni per fornire e migliorare i nostri servizi:',
      privacyDataItem1: 'Impostazioni allergeni: Gli allergeni che selezioni per monitorare',
      privacyDataItem2: 'Cronologia scansioni: I codici a barre che scansioni (collegati a un ID anonimo)',
      privacyDataItem3: 'Prodotti preferiti: I prodotti che salvi come preferiti',
      privacyDataItem4: 'Profili allergeni: I profili che crei per diverse persone',
      privacyDataItem5: 'ID utente anonimo: Un identificatore unico generato localmente (UUID) per associare i tuoi dati',
      privacyHowWeUse: 'Come utilizziamo i tuoi dati',
      privacyHowWeUseDesc: 'Utilizziamo i tuoi dati esclusivamente per:',
      privacyUseItem1: 'Analizzare prodotti e rilevare allergeni secondo le tue impostazioni',
      privacyUseItem2: 'Salvare le tue preferenze e preferiti',
      privacyUseItem3: 'Suggerirti prodotti alternativi sicuri',
      privacyUseItem4: 'Migliorare l\'esperienza dell\'app',
      privacyNoShare: 'Non condividiamo i tuoi dati',
      privacyNoShareDesc: 'I tuoi dati non vengono mai venduti o condivisi con terze parti. Le informazioni sono archiviate in modo sicuro e utilizzate solo per il funzionamento dell\'app.',
      privacyRights: 'I tuoi diritti',
      privacyRightsDesc: 'Hai il diritto di:',
      privacyRightItem1: 'Accedere ai tuoi dati archiviati',
      privacyRightItem2: 'Eliminare i tuoi dati in qualsiasi momento',
      privacyRightItem3: 'Esportare i tuoi dati',
      privacyRightItem4: 'Revocare i permessi di accesso',
      privacyContact: 'Contatti',
      privacyContactDesc: 'Se hai domande su questa informativa sulla privacy, puoi contattarci a:',
      privacyCookies: 'Cookie e archiviazione locale',
      privacyCookiesDesc: 'Utilizziamo localStorage per salvare il tuo ID utente anonimo e le preferenze. Non utilizziamo cookie di tracciamento di terze parti.',
      privacyChanges: 'Modifiche a questa informativa',
      privacyChangesDesc: 'Potremmo aggiornare questa informativa occasionalmente. Ti informeremo di eventuali modifiche significative tramite l\'app.'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
